<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<p class="title"><em class="italic">Debbie Shore’s</em></p>
<p class="title1a">SEWING ROOM SECRETS</p>
<p class="title1"><span class="bold">Quilting</span></p>
<div class="img_container">
<img alt="Image" src="images/half.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Halftitle.vue?773431be